<template>
  <div class="mb-12">
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="35%"
      center
      class="ne-oppop"
      v-if="this.selectedPlan[0].subscription.name !== ''"
    >
      <div class="bg-primary p-4 flex justify-between items-center">
        <h2 class="text-white fsize14 my-0">Domain</h2>
        <feather-icon
          icon="XIcon"
          svgClasses="w-4 h-4"
          class="cursor-pointer text-white"
          @click="
            () => {
              centerDialogVisible = false;
            }
          "
        />
      </div>
      <div class="p-4 items-center">
        <div class="flex justify-center w-full">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
            class="new-height"
          />
        </div>

        <p class="fsize14 text-dark text-center font-medium my-4">
          Domain is available only for other BRAINED's Subscription Plans.
          Please upgrade to other plan to access this feature
        </p>

        <div class="flex w-full mt-4 gap-2">
          <vs-button
            color="primary"
            class="bg-primary sm-button w-full"
            @click="
              () => {
                centerDialogVisible = false;
                this.$router.push({ name: 'plans-vue' });
              }
            "
            >Upgrade</vs-button
          >

          <vs-button
            color="secondary"
            class="bg-secondary sm-button w-full"
            @click="centerDialogVisible = false"
            >Cancel</vs-button
          >
        </div>
      </div>
    </el-dialog>
    <h2 class="text-565656 fsize18 font-semibold border-b pb-4">Settings</h2>
    <div class="grid gap-4 grid-cols-3 mt-6">
      <div
        class="cursor-pointer effecthover rounded-lg"
        v-for="(item, index) in filteredCards"
        :key="'item -' + index"
        @click="handleClick(item)"
        :class="
          selectedProject.intellectualProperty === true
            ? item.title != 'Intellectual Property'
              ? 'cursor-not-allowed opacity'
              : 'cursor-pointer'
            : ''
        "
      >
        <div class="flex items-center bg-lightf4f5f6 border-round p-3">
          <div class="flex gap-4 items-center w-10/12">
            <img
              :src="item.image"
              class="object-contain w-16 h-16 bg-ec rounded-lg p-1"
              alt="banh"
            />

            <div class="w-full">
              <h3 class="col-4f fsize14 font-medium mb-0">
                {{ item.title }}
              </h3>
            </div>
          </div>
          <div class="w-2/12 flex justify-end cursor-pointer">
            <div>
              <!-- <img
                src="@/assets/images/aright.png"
                class="w-35px rounded-full"
              /> -->
              <div
                class="flex justify-center bg-light-secondary rounded-full items-center w-10 h-10"
              >
                <feather-icon
                  icon="ChevronRightIcon"
                  svgClasses="w-5 h-5"
                  class="text-secondary font-semibold flex"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="relative mt-32">
      <img
        src="@/assets/1images/banh.png"
        class="object-cover ban-he w-full border-round"
        alt="banh"
      />
      <div class="absolute top-0 px-10 ban-he flex items-center">
        <div class="">
          <p class="font-semibold fsize16 mb-0 text-white flex items-center">
            Website Development
          </p>
          <h2 class="text-white text-3xl my-0 font-semibold">
            Create a stunning Business website
          </h2>
          <small class="font-normal fsize12 text-white flex items-center">
            An asset that boosts your business 24*7
          </small>
          <vs-button
            variant="primary"
            class="rounded-full bg-white border-0 text-primary font-medium fsize16 lg:py-2 mt-3 md:py-3 py-2 px-6 sm-fsize14"
          >
            Get Started
          </vs-button>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      centerDialogVisible: false,
      plans: "",
      cards: [
        {
          id: "01",
          title: "Payment Gateway",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/assets/2.png",
          route: "coming",
          route: "settings-Payment",
        },
        {
          id: "02",

          title: "Domain",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/assets/5.png",
          route: "domain",
        },
        {
          id: "08",

          title: "Notifications",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/assets/6.png",
          route: "coming",
          // route: "notifications",
        },
        {
          id: "03",

          title: "Email Templates",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/assets/7.png",
          // route: "coming",
          route: "settings-EmailTemplates",
        },
        {
          id: "04",

          title: "SMS Templates",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/assets/8.png",
          route: "settings-SMSTemplates",
          // route: "coming",
        },
        {
          id: "05",

          title: "Version",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/assets/10.png",
          route: "settings-version",
        },
        {
          id: "06",

          title: "Admin Management",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/assets/12.png",
          route: "settings-Adminmanagement",
        },
        {
          id: "07",

          title: "Error Management",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/assets/13.png",
          // route: "coming",
          route: "settings-errormanagement",
        },
        {
          id: "08",

          title: "Google Analytics",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/assets/14.png",
          route: "google-analytics",
        },
        {
          id: "09",

          title: "Role Management",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/assets/Role Management.png",
          route: "settings-Rolemanagement",
        },
        // {
        //   id: "10",

        //   title: "Contact Us",
        //   image: require("@/assets/images/icons/user management.svg"),
        //   route: "contactUs",
        // },
        {
          id: "11",

          title: "Intellectual Property",
          image: require("@/assets/images/icons/user management.svg"),
          route: "intellectualProperty",
        },
      ],
    };
  },
  computed: {
    ...mapState("admin", ["login", "userModules", "selectedPlan"]),
    ...mapState("modules", ["modulesList"]),
    ...mapState("user", ["selectedProject"]),

    filteredCards() {
      if (
        !["Admin", "Developer"].includes(this.login.role) &&
        this.userModules &&
        this.userModules.length
      ) {
        const menu = this.cards.filter((x) => {
          return this.userModules.find(
            (y) => y.toLowerCase() === x.title.toLowerCase()
          );
        });
        return menu;
      } else {
        return this.cards;
      }
    },
  },
  methods: {
    async getPlans() {
      const { data } = await this.$store.dispatch("billing/getAllPlans");
      this.plans = data;
    },
    handleClick(item) {
      console.log(item, "thissss");
      if (this.selectedProject.intellectualProperty === true) {
        if (
          item.title === "Intellectual Property" ||
          item.title === "Google Analytics"
        ) {
          console.log(item, "if");
          let access = false;
          this.modulesList.forEach((x) => {
            if (x.name === item.title) {
              access = x.access_control;
            }
          });
          if (!access) {
            this.$router.push({ name: "coming" });
          } else {
            if (item.title === "Domain") {
              if (this.selectedPlan[0].subscription.name === "Free") {
                this.centerDialogVisible = true;
              } else {
                this.centerDialogVisible = false;
                this.$router.push({ name: item.route });
              }
            } else {
              this.$router.push({ name: item.route });
            }
          }
        }
      } else {
        console.log(item, "else");
        let access = false;
        this.modulesList.forEach((x) => {
          if (x.name === item.title) {
            access = x.access_control;
          }
        });
        if (!access) {
          this.$router.push({ name: "coming" });
        } else {
          if (item.title === "Domain") {
            if (this.selectedPlan[0].subscription.name === "Free") {
              this.centerDialogVisible = true;
            } else {
              this.centerDialogVisible = false;
              this.$router.push({ name: item.route });
            }
          } else {
            this.$router.push({ name: item.route });
          }
        }
      }
    },
  },
  async mounted() {
    await this.getPlans();
  },
};
</script>
